module.exports = "/assets/kinley.jpg?bXu+Tt/";